<vdr-card class="mb-2" [title]="'userLevel.user-point-records' | translate">
  <ng-container *ngIf="customer$ | async as customer">
    <user-points-records-table [customerId]="customer.id" />
  </ng-container>
</vdr-card>
